import { Output, EventEmitter, Input, OnInit } from '@angular/core';
import { WorkFieldUserChangeEvent } from '../../../events/work-field-user-change-event';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';

export class E5coreUiWorkCasenotesBaseComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() readonly: boolean ;
  @Input() pagesizes: number[] ;

  ngOnInit(): void {
  }

}
